export default __webpack_public_path__ + "static/media/contact.23c34520.svg";